<template lang="pug">
.input-image-list
  transition-group(name="slide-fade")
    shInputImage(v-for="(data, index) in dataForm[property]" :key="id[index]" :class="{'next-input-optional': !data && index != 0}" :dataForm="dataForm" :dataOriginal="dataOriginal" :title="title" :property="property" :brand="brand" :folder="folder" :subfolder="subfolder" :index="index" @load="imageLoaded(index)" @error="imageError(index)" @input="addInput(dataForm[property], index)" @discard="discard(dataForm[property], index)" :imagePath="imagePath" :noImagePath="noImagePath" :classContainerImage="classContainerImage" :required="required")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shInputImage from '@/components/elements/InputImage'

export default {
  name: 'ImageInputList',

  mixins: [mForm, mFilters],

  components: { shInputImage },

  props: {
    dataForm: Object,
    title: String,
    property: String,
    dataOriginal: Object,
    fillData: Boolean,
    folder: String,
    subfolder: String,
    noImagePath: String,
    classContainerImage: String,
    required: Number,
    brand: String
  },

  data () {
    return {
      i: 0,
      id: [0]
    }
  },

  beforeUpdate () {
    this.initIdKeys()
    this.addInput()
  },

  created () {
    this.initIdKeys()
    this.addInputIfUpdate()
    this.addInputDependRequire()
    this.addIfNoLength()
  },

  methods: {
    initIdKeys () {
      if (Array.isArray(this.dataForm[this.property])) {
        this.i = this.dataForm[this.property].length || 0
        this.id = this.dataForm[this.property].map((_, index) => index)
      }
    },

    addInputIfUpdate (data = this.dataForm) {
      const array = data[this.property]
      const lastElement = array[array.length - 1]

      if (this.fillData && lastElement) {
        this.pushEmpty(data[this.property])
      }
    },

    addInputDependRequire (data = this.dataForm) {
      if (!this.fillData && (this.required !== 0)) {
        for (let i = 1; i < this.required; i++) {
          this.pushEmpty(data[this.property])
        }
      }
    },

    addIfNoLength () {
      if (!this.dataForm[this.property].length) this.pushEmpty(this.dataForm[this.property])
    },

    imageLoaded () {},
    imageError (index) {
    }
  },

  watch: {
    dataForm: {
      handler (newVal, oldVal) {
        const diferenceLength = newVal[this.property].length - oldVal[this.property].length

        if (diferenceLength > 0) {
          for (let i = 0; i < diferenceLength; i++) {
            this.id.push(this.i++)
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.input-image-list
  width 100%
  position relative

.delete-button
  position absolute
  right .7em
  top 1.6em
</style>



// WEBPACK FOOTER //
// src/components/elements/InputImageList.vue